import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import CommentListItemController from "controllers/comment/CommentListItemController";
import CommentBoxController from "controllers/comment/CommentBoxController";
import CollectionRepeatController from "controllers/common/CollectionRepeatController";
import SongContextController from "controllers/common/SongContextController";
import CapsuleContextController from "controllers/common/CapsuleContextController";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import PersistentModels from "services/PersistentModels";
import Utils from "models/helper/Utils";
import CommentListOptionView from "views/comment/CommentListOptionView";
import Comments from "collections/Comments";
import ti18n from "i18n!nls/Commenti18n";
import RSVP from "rsvp";

const CommentListOptionController = Chaplin.Controller.extend({

    initialize : function(options) {
        _.extend(this, Backbone.Events);
        this.model = options.model;
        this.context = options.context;
        this._disableReply = options.disableReply;
        this._idOfCommentToFocusOn = options.idOfCommentToFocusOn;
        this.commentsCollection = null;
        this.songRefSummary = options.songRefSummary;
        const controllerParams = {};
        controllerParams.disableReply = this._disableReply;
        controllerParams.context = this.context;
        const collectionRepeatControllerParams = {};
        collectionRepeatControllerParams.customInfoBoxInfoParams = this._buildInfoBoxParams();
        collectionRepeatControllerParams.showEmtptyInfoBox = true;
        collectionRepeatControllerParams.controllerOption = controllerParams;
        collectionRepeatControllerParams.itemControllerConstructor = CommentListItemController;
        collectionRepeatControllerParams.resizePlaceHolderElem = true;
        collectionRepeatControllerParams.modelLoadHandler = options.loadHandler?options.loadHandler: this._getCommentsForSongLoadHandler.bind(this);
        if(options.context){
            collectionRepeatControllerParams.context = options.context;
        }
        this.collectionRepeatController = new CollectionRepeatController(collectionRepeatControllerParams);
        let commentBoxControllerParams =  {};
        let contextControllerParams = {};
        commentBoxControllerParams.commentContext = this.model;
        commentBoxControllerParams.songRefSummary =  this.songRefSummary;
        commentBoxControllerParams.context = this.context;
        this._commentBoxController = new CommentBoxController(commentBoxControllerParams);
        //this.listenTo(this.collectionRepeatController,"finishLoading", this._onCollecctionRepeaterFinishLoading.bind(this));
        this._contextController  = null;
        if(Utils.getInstance().isSongInstance(this.model)){
            contextControllerParams = {};
            contextControllerParams.model = this.model;
            this._contextController = new SongContextController(contextControllerParams);
        }else{
            if(Utils.getInstance().isCommentInstance(this.model)){
                contextControllerParams = {};
                contextControllerParams.model = this.model;
                contextControllerParams.disableReply = true;
                this._contextController = new CommentListItemController(contextControllerParams);
            }else{
                if(Utils.getInstance().isCapsuleInstance(this.model)){
                    contextControllerParams = {};
                    contextControllerParams.model = this.model;
                    contextControllerParams.disableReply = true;
                    this._contextController = new CapsuleContextController(contextControllerParams);
                }else{

                }
            
            }
        }

    },
    

    
    _onAfterShow : function(){
        this.focusOnCommentWithId(this._idOfCommentToFocusOn);
        this._idOfCommentToFocusOn = null;
    },
    
    _buildInfoBoxParams : function(){
        const params = {};
        params.iconClass = "ion-chatbox";
        params.message = window.getI18n(ti18n,"NO_COMMENT");
        params.helpMessage = window.getI18n(ti18n,"POST_A_COMMENT_TO_START_A_DISCUSSION");
        return params;
        
    },
    
    
    _getCommentsForSongLoadHandler: function(){
        if(this.model ){
            if(Utils.getInstance().isSongInstance(this.model)){
                const songJsonForBackend = Utils.getInstance().getSongJsonForBackendFromSongModel(this.model);
                return TrebbleClientAPIHelper.getInstance().getCommentsInfoForSong(songJsonForBackend, this.songRefSummary).then((function(commentsArray){
                    this.commentsCollection = new Comments(commentsArray);
                    return this.commentsCollection.models;
                }).bind(this));
            }else{
                if(Utils.getInstance().isCommentInstance(this.model)){
                    const commentId = this.model.getCommentId();
                    return TrebbleClientAPIHelper.getInstance().getRepliesForComment(commentId).then((function(commentsArray){
                        this.commentsCollection = new Comments(commentsArray);
                        return this.commentsCollection.models;
                    }).bind(this));
                }else{
                    if(Utils.getInstance().isCapsuleInstance(this.model)){
                        const capsuleId = this.model.getCapsuleId();
                        return TrebbleClientAPIHelper.getInstance().getCommentsInfoForCapsule(capsuleId, this.songRefSummary).then((function(commentsArray){
                            this.commentsCollection = new Comments(commentsArray);
                            return this.commentsCollection.models;
                        }).bind(this));
                    }else{
                        return RSVP.Promise.resolve();
                    }
                }
            }
        }else{
            return RSVP.Promise.resolve();
        }
    },

    getModel : function() {
        return this.model;
    },

    getView : function() {
        return this.view;
    },
    
    _onNewCommentPosted : function(newCommentModel){
        if(newCommentModel){
            this.collectionRepeatController.addItemToBottom(newCommentModel);
        }
    },
    
    _notifyCommentConsumed : function(){
        if(this.model ){
            if(Utils.getInstance().isSongInstance(this.model)){
                return PersistentModels.getInstance().notifyUserOfUnconsumedOwnerComments(this.model, this.context, this.songRefSummary);
            }else{
                if(Utils.getInstance().isCommentInstance(this.model)){
                    const commentId =  this.model.getCommentId();
                    return TrebbleClientAPIHelper.getInstance().markCommentRepliesAsConsumed(commentId);
                }else{
                    if(Utils.getInstance().isCapsuleInstance(this.model)){
                        const capsuleId = this.model.getCapsuleId();
                        return PersistentModels.getInstance().notifyUserOfUnconsumedCapsuleComments(capsuleId, this.context, this.songRefSummary);
                    }else{
                        return RSVP.Promise.resolve();
                    }
                }
            }
        }else{
            return RSVP.Promise.resolve();
        }
    },
    
    focusOnCommentWithId : function(commentId){
        const commentModel  = this.commentsCollection ? this.commentsCollection.get(commentId): null;
        if(commentModel){
            this.collectionRepeatController.focusOnItem(commentModel);
        }
    },

    buildModelAndRenderView : function() {
        $.mobile.loading("show");
        return new RSVP.Promise((function(resolve, reject) {
            try {
                const promises = [];
                this.listenTo(this._commentBoxController, "newCommentCreated", this._onNewCommentPosted.bind(this));
                promises.push(this._commentBoxController.buildModelAndRenderView());
                promises.push(this.collectionRepeatController.buildModelAndRenderView());
                if(this._contextController){
                    promises.push(this._contextController.buildModelAndRenderView());
                }
                RSVP.Promise.all(promises).then((function(result){
                    const commentListOptionViewParams = {};
                    commentListOptionViewParams.commentListView = this.collectionRepeatController.getView();
                    commentListOptionViewParams.commentBoxView = this._commentBoxController.getView();
                    if(this._contextController){
                        commentListOptionViewParams.commentContextView = this._contextController.getView();
                    }
                    if(Utils.getInstance().isCommentInstance(this.model)){
                        this.collectionRepeatController.getView().$el.css("padding-left","40px");
                    }
                    commentListOptionViewParams.onAfterShow = this._onAfterShow.bind(this);
                    const commentListOptionView = new CommentListOptionView(commentListOptionViewParams);
                    commentListOptionView.render();

                    this._notifyCommentConsumed();
                    $.mobile.loading("hide");
                    //this.capsuleListController.getView().load();
                    this.view = commentListOptionView;
                    resolve();
                }).bind(this)).catch((function(error){
                    $.mobile.loading("hide");
                    reject(error);
                }).bind(this));
                
            } catch (error) {
                $.mobile.loading("hide");
                reject(error);
            }

        }).bind(this));

    }

});

export default CommentListOptionController;